import Typography from '@mui/material/Typography';
import React from 'react';
import { imageProxy } from 'tf-post-parser';
import BlogMenu from '../CuratorMenu/BlogMenu';
import ProfileAvatar from './ProfileAvatar';

const AuthorProfileHeader = props => {
  const coverImage =
    props.data.coverImage && props.data.coverImage !== ''
      ? imageProxy(props.data.coverImage, 1500)
      : '';
  const divStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0,0.5)),
    url("${coverImage}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    height: '300px',
  };
  return (
    <>
      <div className="text-center p-4 mb-3" style={divStyle} />
      <div className="container-fluid pb-3">
        <div className="row justify-content-center text-center">
          <div className="col-12 p-0" style={{ marginTop: '-115px' }}>
            <div className="d-flex justify-content-center">
              <ProfileAvatar
                withBorder
                authorAvatar={props.data.profileImage}
                author={props.data.name}
                size={200}
              />
            </div>
          </div>
          <div className="col-12 col-xl-4 col-lg-4 col-md-6 col-sm-8 pt-2">
            <Typography variant="h5" color="textPrimary">
              {props.data.name && (
                <strong>
                  {props.data.name === props.data.displayName
                    ? `@${props.data.name}`
                    : props.data.displayName}
                </strong>
              )}
              {props.data.isBlacklisted && (
                <>
                  {' '}
                  <span className="h5 pt-1 badge badge-danger">
                    Blacklisted
                  </span>
                </>
              )}
              {props.data.isCurator && (
                <>
                  {' '}
                  <span className="h5 pt-1 badge badge-success">Team</span>
                </>
              )}
            </Typography>
            {props.data.name && props.data.name !== props.data.displayName ? (
              <Typography variant="h6" color="textSecondary">
                @{props.data.name}
              </Typography>
            ) : (
              <></>
            )}
            <BlogMenu
              author={props.data.name}
              isCurator={props.data.isCurator}
              isVideo={props.data.isVideo}
            />
          </div>
        </div>
      </div>
    </>
  );
};

AuthorProfileHeader.defaultProps = {
  name: '',
  isBlacklisted: false,
  isCurator: false,
};

export default AuthorProfileHeader;
